import { Icon } from "../ui/Icon";
import { type Formula, type Operand, OP_SYMBOL, OP_OPTIONS, MAX_FORMULA_STEPS, formulaToString } from "../../lib/formFormula";
// Bileşen kendi stillerini taşır (kod tabanı deseni) — form builder DIŞINDA da (pano kart editörü) kullanılıyor.
import "../../pages/Forms.css";

/** Builder'da hesaplanan (formül) alan düzenleyicisi: başlangıç operandı + sıralı işlemler + canlı önizleme. */
const CONST = "__const__";

type Candidate = { refKey: string; label: string };

function OperandInput({ candidates, operand, onChange }: { candidates: Candidate[]; operand: Operand; onChange: (o: Operand) => void }) {
  const sel = operand.kind === "const" ? CONST : operand.ref;
  return (
    <div style={{ display: "flex", gap: 6, flex: 1, minWidth: 0 }}>
      <select
        className="form-select"
        value={sel}
        aria-label="Operand (alan veya sabit)"
        style={{ flex: 1, minWidth: 0 }}
        onChange={(e) => {
          const v = e.target.value;
          if (v === CONST) onChange({ kind: "const", value: operand.kind === "const" ? operand.value : 0 });
          else onChange({ kind: "field", ref: v });
        }}
      >
        <option value="" disabled>Alan / sabit…</option>
        {candidates.map((c) => <option key={c.refKey} value={c.refKey}>{c.label}</option>)}
        <option value={CONST}>Sabit sayı…</option>
      </select>
      {operand.kind === "const" ? (
        <input className="form-input" type="number" step="any" value={String(operand.value)} placeholder="0" aria-label="Sabit değer" style={{ width: 96 }} onChange={(e) => onChange({ kind: "const", value: e.target.value === "" ? 0 : Number(e.target.value) })} />
      ) : null}
    </div>
  );
}

export function FormulaEditor({ candidates, value, onChange, hint }: { candidates: Candidate[]; value: Formula; onChange: (f: Formula) => void; hint?: string }) {
  const labelOf = (ref: string) => candidates.find((c) => c.refKey === ref)?.label ?? "";
  const setStart = (o: Operand) => onChange({ ...value, start: o });
  const setStep = (i: number, patch: Partial<{ op: Formula["steps"][number]["op"]; operand: Operand }>) =>
    onChange({ ...value, steps: value.steps.map((s, idx) => (idx === i ? { ...s, ...patch } : s)) });
  const addStep = () =>
    onChange({ ...value, steps: [...value.steps, { op: "+", operand: candidates[0] ? { kind: "field", ref: candidates[0].refKey } : { kind: "const", value: 0 } }] });
  const removeStep = (i: number) => onChange({ ...value, steps: value.steps.filter((_, idx) => idx !== i) });

  return (
    <div className="fb-formula">
      <div className="fb-formula-row">
        <span className="fb-formula-lbl">Başlangıç</span>
        <OperandInput candidates={candidates} operand={value.start} onChange={setStart} />
      </div>
      {value.steps.map((s, i) => (
        <div className="fb-formula-row" key={i}>
          <select className="form-select fb-formula-op" value={s.op} aria-label="İşlem" onChange={(e) => setStep(i, { op: e.target.value as Formula["steps"][number]["op"] })}>
            {OP_OPTIONS.map((op) => <option key={op} value={op}>{OP_SYMBOL[op]}</option>)}
          </select>
          <OperandInput candidates={candidates} operand={s.operand} onChange={(o) => setStep(i, { operand: o })} />
          <button type="button" className="fb-iact danger" aria-label="İşlemi kaldır" title="İşlemi kaldır" onClick={() => removeStep(i)}><Icon name="trash" size={13} /></button>
        </div>
      ))}
      <button type="button" className="btn-md secondary" style={{ height: 30, padding: "0 11px", fontSize: 12.5, alignSelf: "flex-start" }}
        onClick={addStep} disabled={value.steps.length >= MAX_FORMULA_STEPS} title={value.steps.length >= MAX_FORMULA_STEPS ? `En fazla ${MAX_FORMULA_STEPS} işlem` : undefined}>
        <Icon name="plus" size={13} />İşlem ekle
      </button>
      <div className="fb-formula-preview">
        <span className="fb-formula-preview-lbl">Sonuç =</span>
        <code>{formulaToString(value, labelOf)}</code>
      </div>
      <p className="help" style={{ margin: 0 }}>{hint ?? "İşlemler soldan sağa sırayla uygulanır. Bu alan doldurmada otomatik hesaplanır (kullanıcı giremez)."}</p>
    </div>
  );
}
